import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_jewelry_storage: FaireCategoryEntity = {
  token: "catalog_cat_jewelry-storage",
  type: "category",
  name: "Jewelry storage & care",
  count: 16,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
